var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16669 17.2917C4.68335 17.2917 1.04169 13.65 1.04169 9.16669C1.04169 4.68335 4.68335 1.04169 9.16669 1.04169C13.65 1.04169 17.2917 4.68335 17.2917 9.16669C17.2917 13.65 13.65 17.2917 9.16669 17.2917ZM9.16669 2.29169C5.37502 2.29169 2.29169 5.37502 2.29169 9.16669C2.29169 12.9584 5.37502 16.0417 9.16669 16.0417C12.9584 16.0417 16.0417 12.9584 16.0417 9.16669C16.0417 5.37502 12.9584 2.29169 9.16669 2.29169Z",
    fill: "#919191"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 9.79169H7.08334C6.74168 9.79169 6.45834 9.50835 6.45834 9.16669C6.45834 8.82502 6.74168 8.54169 7.08334 8.54169H11.25C11.5917 8.54169 11.875 8.82502 11.875 9.16669C11.875 9.50835 11.5917 9.79169 11.25 9.79169Z",
    fill: "#919191"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8001 18.9917C16.7334 18.9917 16.6668 18.9834 16.6084 18.975C16.2168 18.925 15.5084 18.6584 15.1084 17.4667C14.9001 16.8417 14.9751 16.2167 15.3168 15.7417C15.6584 15.2667 16.2334 15 16.8918 15C17.7418 15 18.4084 15.325 18.7084 15.9C19.0084 16.475 18.9251 17.2084 18.4501 17.9167C17.8584 18.8084 17.2168 18.9917 16.8001 18.9917ZM16.3001 17.075C16.4418 17.5084 16.6418 17.725 16.7751 17.7417C16.9084 17.7584 17.1584 17.6 17.4168 17.225C17.6584 16.8667 17.6751 16.6084 17.6168 16.4917C17.5584 16.375 17.3251 16.25 16.8918 16.25C16.6334 16.25 16.4418 16.3334 16.3334 16.475C16.2334 16.6167 16.2168 16.8334 16.3001 17.075Z",
    fill: "#919191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchZoomOut);
export default __webpack_public_path__ + "static/media/search-zoom-out.364dad0d375d18e30619f17c474a4110.svg";
export { ForwardRef as ReactComponent };